"use client";

import { CalloutBanner as CalloutBannerComposite } from "@/composites/landing";
import type { Cta, CmsImage } from "@/composites/landing/types";
import { useForwardedCta } from "@/app/utilities/query-params/use-forwarded-cta";

export interface CalloutBannerBlock {
	blockType: "callout_banner";
	eyebrow?: string;
	headline: string;
	subcopy?: string;
	primary_cta?: Cta;
	secondary_cta?: Cta;
	background_image?: CmsImage;
}

/**
 * Adapter for the `callout_banner` block. Maps the typed CMS payload to the
 * `CalloutBanner` composite — no styling, no fetching. Mirrors `InviteHero`;
 * adds a `secondary_cta` Link.
 *
 * Only the primary CTA carries the visitor's params. The secondary CTA is a
 * plain navigation link, so it is left alone.
 */
export function CalloutBanner({ block }: { block: CalloutBannerBlock }) {
	const withForwardedCta = useForwardedCta();

	return (
		<CalloutBannerComposite
			eyebrow={block.eyebrow}
			headline={block.headline}
			body={block.subcopy}
			primaryCta={withForwardedCta(block.primary_cta)}
			secondaryCta={block.secondary_cta}
			backgroundImage={block.background_image}
		/>
	);
}
